import { render, staticRenderFns } from "./student-update.vue?vue&type=template&id=7a702ee4&"
import script from "./student-update.vue?vue&type=script&lang=js&"
export * from "./student-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports